export function createSwiperControls(appendTo) {
    if (!appendTo || appendTo?.querySelector('.custom-swiper-controls'))
        return;
    const Wrapper = document.createElement('div');
    Wrapper.classList.add('custom-swiper-controls');
    Wrapper.innerHTML = `
  <button class='custom-swiper-controls__prev-button'>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 6.21916C16.0976 6.60969 16.0976 7.24285 15.7071 7.63338L10.4142 12.9263L15.7071 18.2192C16.0976 18.6097 16.0976 19.2429 15.7071 19.6334C15.3166 20.0239 14.6834 20.0239 14.2929 19.6334L8.29289 13.6334C7.90237 13.2429 7.90237 12.6097 8.29289 12.2192L14.2929 6.21916C14.6834 5.82864 15.3166 5.82864 15.7071 6.21916Z" fill="#F7F7F8"/>
    </svg>
  </button>
  <div class="custom-swiper-pagination"></div>
  <button class='custom-swiper-controls__next-button'>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 6.21916C8.68342 5.82864 9.31658 5.82864 9.70711 6.21916L15.7071 12.2192C16.0976 12.6097 16.0976 13.2429 15.7071 13.6334L9.70711 19.6334C9.31658 20.0239 8.68342 20.0239 8.29289 19.6334C7.90237 19.2429 7.90237 18.6097 8.29289 18.2192L13.5858 12.9263L8.29289 7.63338C7.90237 7.24285 7.90237 6.60969 8.29289 6.21916Z" fill="#F7F7F8"/>
    </svg>
  </button>
  `;
    appendTo.appendChild(Wrapper);
}
